import { updateSelectedIds } from '@store';
import { checkIdProperty } from '@utils';

import { CheckBox } from '@components/Forms';
import { useAppDispatch, useFormSelectedList } from '@hooks';
import type { DraggableItem, FormMetadata } from '@types';

interface CheckBoxTableCellDefaultProps<T> extends FormMetadata {
  data: T;
}

export const CheckBoxTableCell = <T extends DraggableItem>({
  formType,
  endpoint,
  data,
}: CheckBoxTableCellDefaultProps<T>) => {
  const selectedData = useFormSelectedList({ formType, endpoint });
  const dispatch = useAppDispatch();

  const handleCheckBox = () => {
    dispatch(updateSelectedIds({ formType, endpoint, id: String(data.id) }));
  };
  if (!checkIdProperty(data)) return;
  const isChecked = selectedData?.includes(String(data?.id)) ?? false;

  return <CheckBox id={data?.id} checked={isChecked} onChange={handleCheckBox} />;
};
